import { faImages, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  getSupplierListApi,
  removeImageApi,
  getFoodCategoryApi,
  getDetailProductSupperyApi,
  EditSuperyProductPostApi,
} from "../../../Api/PanelAdminServices";
import Style from "./EditResturanFoodForm.module.scss";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
const EditResturanFoodForm = ({ info, updateData }) => {
  const [imgs, setImgs] = useState([]);
  const [files, setFiles] = useState([]);
  const [disable, setDisable] = useState(false);
  const [supllierListState, setSupllierState] = useState(null);
  const [selectSupplierState, setSelectSupllierState] = useState(null);
  const [selectCategoryState, setSelectCategoryState] = useState(null);
  const [categoriesState, setCategoriesState] = useState(null);
  const [ProductDetailState, setProductDetailState] = useState(null);
  const [packed, setPacked] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    getProductDetail();
    if (info.Supplier) {
      getCategoryHandler(info.SupplierId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getCategoryHandler = async (id) => {
    getFoodCategoryApi(id,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setCategoriesState(res.category);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    });
  };

  const getProductDetail = async () => {
    getDetailProductSupperyApi(info.ProductId,info.SupplierId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setProductDetailState(res.product);
          setImgs(res.product.img);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })

    getSupplierListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          let resturants = [];
          res.suppliers.forEach((e) => {
            if (e.type === "food") {
              resturants.push(e);
            }
          });
          setSupllierState(resturants);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };

  const removeImage = (name) => {
    const infoData = {
      product_id: info.ProductId,
      file: name,
    };
    removeImageApi(infoData, (res) => {
      //   getImages();
    });
  };

  const removeUploadImage = (name) => {
    setFiles((oldState) => oldState.filter((item) => item !== name));
  };
  const UploadImage = async (images) => {
    return await resizeFile(images);
  };

  const resizeFile = (file) => {
    for (let i = 0; i < file.length; i++) {
      Resizer.imageFileResizer(
        file[i],
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setFiles((prevfiles) => [...prevfiles, uri]);
        },
        "base64"
      );
    }
  };

  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const supplierOnChangeHandler = (value) => {
    setSelectSupllierState(value);
    getCategoryHandler(value.value);
  };
  const CategoryOnChangeHandler = (value) => {
    setSelectCategoryState(value);
  };

  let defaultSupllier =
    supllierListState &&
    supllierListState.filter((option) => option.id === info.SupplierId);
  let defaultCategory =
    ProductDetailState &&
    categoriesState &&
    categoriesState.filter(
      (option) => option.id === ProductDetailState.category_free_id
    );

  const onSubmit = (data) => {
    setDisable(true);
    let Values = {
      product_id: info.ProductId,
      brand_id: "1",
      barcode_1: 0,
      barcode_2: 0,
      barcode_3: 0,
      name: data.name,
      category_id: "1",
      other_detail: data.other_detail,
      volume: 0,
      weight: 0,
      file: files,
      supplier_id:
        selectSupplierState === null
          ? info.SupplierId
          : selectSupplierState.value,
      supplier_id_prev: info.SupplierId,
      exist: data.exist,
      category_free_id:
        selectCategoryState === null
          ? ProductDetailState.category_free_id
          : selectCategoryState.value,
      price: data.price,
      off_price: data.off_price,
      packed: packed ? 1 : -1,
    };
    EditSuperyProductPostApi(Values, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        setDisable(false);
        updateData();
      } else {
        setDisable(false);
        errorToast(succ.message);
      }
    });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className={Style.FormHolder}>
      <div className={Style.imagePart}>
        {imgs.map((item, index) => {
          return (
            <div key={index} className={Style.eachImage}>
              <div className={Style.picHolder}>
                <img
                  src={`https://cdn.barest.ir/product/m/${item}.jpg?${randomNumberInRange(
                    1,
                    1000000000000
                  )}`}
                  alt=""
                />
              </div>
              <div
                className={Style.iconHolder}
                onClick={() => removeImage(item)}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </div>
            </div>
          );
        })}

        {files.map((item, index) => {
          return (
            <div key={index} className={Style.eachImage}>
              <div className={Style.picHolder}>
                <img src={item} alt="" />
              </div>
              <div
                className={Style.iconHolder}
                onClick={() => removeUploadImage(item)}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </div>
            </div>
          );
        })}
      </div>

      <div className={Style.inptFileHolder}>
        <label className={Style.lablePart} htmlFor="imgSelect">
          <FontAwesomeIcon icon={faImages} />
        </label>
        <p className={Style.placeHolderInput}>بارگذاری تصویر</p>
        <input
          className={Style.fileInputPart}
          type="file"
          id={"imgSelect"}
          onChange={(e) => UploadImage(e.target.files)}
          multiple
        />
      </div>
      <input
        {...register("name", { required: true })}
        className={errors.name ? Style.errorInput : Style.fileInputPart2}
        placeholder={" نام محصول"}
        defaultValue={info.ProductName}
      />
      {supllierListState && (
        <Select
          onChange={(e) => supplierOnChangeHandler(e)}
          options={supllierListState.map((item) => {
            return { label: item.name, value: item.id };
          })}
          defaultValue={
            defaultSupllier[0] && {
              label: defaultSupllier[0].name,
              value: defaultSupllier[0].id,
            }
          }
          className={Style.selectHolder}
          placeholder={"تامین کننده"}
        />
      )}
      {ProductDetailState && categoriesState && (
        <Select
          onChange={(e) => CategoryOnChangeHandler(e)}
          options={categoriesState.map((item) => {
            return { label: item.category, value: item.id };
          })}
          defaultValue={
            defaultCategory[0] && {
              label: defaultCategory[0].category,
              value: defaultCategory[0].id,
            }
          }
          className={Style.selectHolder}
          placeholder={"دسته بندی"}
        />
      )}
      {info.packed === "0" ? (
        <label className={Style.packedPart}>
          {" "}
          جزو محصولات بسته بندی شده است
          <input
            onChange={(e) => setPacked(e.target.checked)}
            className={Style.checkedPacked}
            type="checkbox"
          />
        </label>
      ) : null}
      <select
        name=""
        id=""
        {...register("exist", { required: false })}
        defaultValue={ProductDetailState && ProductDetailState.count}
        className={Style.fileInputPart2}
      >
        <option value="1">موجود</option>
        <option value="0">ناموجود</option>
      </select>
      <input
        {...register("price")}
        className={Style.fileInputPart2}
        placeholder={"قیمت"}
        defaultValue={info.prices}
      />
      <input
        {...register("off_price")}
        className={Style.fileInputPart2}
        placeholder={"قیمت با تخفیف"}
        defaultValue={info.off_price}
      />
      {ProductDetailState && (
        <textarea
          {...register("other_detail")}
          className={Style.fileInputPart2}
          placeholder={"توضحیات"}
          defaultValue={ProductDetailState.other_detail}
        />
      )}

      <div>
        <button className={Style.btnStyle} type="submit" disabled={disable}>
          ویرایش
        </button>
      </div>
    </form>
  );
};

export default EditResturanFoodForm;
